import { render, staticRenderFns } from "./EditMemberProfile.vue?vue&type=template&id=bad30536"
import script from "./EditMemberProfile.vue?vue&type=script&lang=js"
export * from "./EditMemberProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports